<template>
  <div :style="styles.base">
    <div
      :class="getCss('fill-container')" :style="animateStyle" ref="mainContainer">
      <template v-if="configurationData.isLazy">
        <template v-for=" (item, index) in statusList">
          <div :key="index" :class="getCss('content-slot')"
               :style="{width:styles.base.width,height:styles.base.height}"
               v-if="item.value === nowStatus"
          >
            <slot :name="`${index}`">
            </slot>
          </div>
        </template>
      </template>
      <template v-else>
        <template v-for=" (item, index) in statusList">
          <div :key="index" :class="getCss('content-slot')"
               :style="{width:styles.base.width,height:styles.base.height}"
               v-show="item.value === nowStatus"
          >
            <slot :name="`${index}`">
            </slot>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin } from '@tencent/ceiba-base-components';
import 'animate.css';
// 空状态标志
const EMPTY_STATUS = Symbol('empty status');
export default {
  name: 'CPublicMultistatusContainer',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'public-multistatus-container-',
      tempStatus: '',
      inTempStatus: false,
      inAnimation: false,
      eventUid: '',
      matchStatus: '',
      mounted: false,
      resAllArr: [],
      refreshNum: 0,
      ruleStatus: false,
    };
  },
  computed: {
    statusList() {
      return this.configurationData.configs.statusList || [];
    },
    // 当前页面展示的状态
    nowStatus() {
      // 编辑器内  不去计算任何规则
      if (this.$isInEditor) {
        return this.configurationData.configs.activeStatus;
      }
      if (this.tempStatus) {
        return this.tempStatus;
      }
      if (this.inTempStatus) {
        return this.configurationData.configs.activeStatus;
      }
      // 随机展示一个状态
      if (!!this.configurationData?.random && !this.$isInEditor) {
        return this.statusList[this.getRandomStatus(this.statusList?.length)].value;
      }
      if (this.matchStatus !== '') {
        return this.matchStatus;
      }
      // 没拿到匹配值 展示默认
      return this.configurationData.configs.activeStatus;
    },
    nowStatusConfig() {
      const { config = {} } = this.statusList.find(item => item.value === this.nowStatus) || {};
      return config;
    },
    baseExtendStyle() {
      const extendStyle = {};
      // 在动画为bounce时,父容器overflow需要设置为visible
      if (this.nowStatusConfig.style?.animate?.['animation-name'] === 'bounce' || this.inAnimation) {
        extendStyle.overflow = 'visible';
      }
      // 没有任何一个状态匹配时,组件隐藏
      if (this.nowStatus === EMPTY_STATUS) {
        extendStyle.display = 'none';
      }
      return extendStyle;
    },
    // nowTimeStr() {
    //   return Date.now();
    // },
    animateStyle() {
      return this?.nowStatusConfig?.style?.animate ?? {};
    },
    isApp() {
      if (this.$ast.isAPP()) {
        return true;
      }
      return false;
    },
    isGame() {
      if (common.platform.isGame) {
        return true;
      }
      return false;
    },
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      const self = this;
      console.log('CPublicMultistatusContainer.statusList', this.configurationData.configs.statusList);
      if (this.configurationData.refreshTimeStatus === 'login') {
        this.$onLogined(async () => {
          await self.refreshTime();
        });
      }
      if (this.configurationData.refreshTimeStatus === 'role') {
        this.$onRoleReady(async () => {
          await self.refreshTime();
        });
      }
      if (this.configurationData.refreshTimeStatus === 'qua') {
        this.$onQuaRefreshed(async () => {
          await this.flowIdListLimitStatus();
          await self.refreshTime();
        });
      }
      this.$eventBus.$on('ceiba:custom:events:refresh:container:status', async () => {
        // 动态调用刷新多状态
        await self.refreshTime();
      });
      if (this.configurationData.flowIdList?.length < 1) {
        self.refreshTime();
      }
    },
    // 获取随机数
    getRandomStatus(statusLength) {
      return parseInt(Math.random() * statusLength, 10);
    },
    setTempStatus({ status, animation }) {
      if (this.inAnimation) return;
      const currentIndex = Math.max(this.statusList.findIndex(item => item.value === this.nowStatus), 0);
      const statusLen = this.statusList.length;
      if (status === 'prev') {
        const preIndex = (statusLen + currentIndex - 1) % statusLen;
        this.tempStatus = this.statusList[preIndex].value;
      } else if (status === 'next') {
        const nextIndex = (statusLen + currentIndex + 1) % statusLen;
        this.tempStatus = this.statusList[nextIndex].value;
      } else {
        this.tempStatus = status;
      }
      this.inTempStatus = true;
      animation && this.animate(animation);
    },
    animate(animation) {
      this.animateOut(animation);
      this.$nextTick(() => {
        this.animateIn(animation);
      });
    },
    animateIn({ animationName, animationDuration }) {
      const inEl = this.$el.firstElementChild.cloneNode(true);
      inEl.classList.add(this.getCss('repeated-el'));
      inEl.classList.remove(this.getCss('hide'));
      inEl.setAttribute('style', `animation-name: ${animationName}; animation-duration: ${animationDuration}ms`); // 清除原有的动画
      this.$el.appendChild(inEl);
      setTimeout(() => {
        this.$el.removeChild(inEl);
      }, animationDuration);
    },
    // 移出动画固定为为淡出
    animateOut({ animationDuration }) {
      this.inAnimation = true;
      const outEl = this.$el.firstElementChild.cloneNode(true);
      this.$el.firstElementChild.classList.add(this.getCss('hide'));
      outEl.classList.add(this.getCss('repeated-el'), this.getCss('fade-out'));
      outEl.setAttribute('style', `animation-duration: ${animationDuration}ms`); // 清除原有的动画
      outEl.classList.add('rotateInDownLeft');
      this.$el.appendChild(outEl);
      setTimeout(() => {
        this.$el.removeChild(outEl);
        this.$el.firstElementChild.classList.remove(this.getCss('hide'));
        this.inAnimation = false;
      }, animationDuration);
    },
    // 刷新时间
    async refreshTime() {
      await this.flowIdListLimitStatus();
      this.refreshNum = this.refreshNum + 1;
      // this.matchStatus = '';
      for (const item of this.statusList) {
        const { ruleList } = item.config.style;
        if (this.matchStatus !== '' && this.refreshNum === 1) {
          return;
        }
        if (ruleList.length >= 1 && item.value !== this.configurationData.configs.activeStatus) {
          this.ruleStatus = true;
          for (const rule of ruleList) {
            console.log('CPublicMultistatusContainer.statusList.rule', rule);
            if (!this.ruleStatus) {
              break;
            }
            switch (rule.rule) {
              case 'flow':
                this.ruleStatus = await this.flowidLimitStatus(rule.flowId, rule.key, rule.op, rule.value);
                break;
              case 'time':
                this.ruleStatus = this.timeLimitStatus(rule.startTime, rule.endTime);
                break;
              case 'acctype':
                this.ruleStatus = this.acctypeLimitStatus(rule.value);
                break;
              case 'plat':
                this.ruleStatus = this.platformLimitStatus(rule.value);
                break;
              case 'isAPP':
                this.ruleStatus = this.isAPPLimitStatus(rule.value);
                break;
              case 'isGame':
                this.ruleStatus = this.isGameLimitStatus(rule.value);
                break;
              case 'userAgent':
                this.ruleStatus = this.userAgentLimitStatus(rule.value);
                break;
              case 'url':
                this.ruleStatus = this.channelIdLimitStatus(rule.value);
                break;
              case 'package':
                this.ruleStatus = this.packageInfoStatus(rule.key, rule.op, rule.value);
                break;
              case 'currentGid':
                this.ruleStatus = this.currentGidStatus(rule.value, rule.op);
                break;
              case 'appVersion':
                this.ruleStatus = this.appVersionLimitStatus(rule.op, rule.value);
                break;
              default:
                this.ruleStatus = false;
                break;
            }
            console.log('CPublicMultistatusContainer.matchStatus.switch', this.ruleStatus);
          }
          if (this.ruleStatus) {
            this.matchStatus = item.value;
          }
          console.log('CPublicMultistatusContainer.matchStatus', this.matchStatus);
        }
      }
    },
    /**
     * 配置参数和实际参数比较
     * @param {string} value 实际返回值
     * @param {string} op 比较符号
     * @param {string} compareValue 比较值
     */
    opStatus(value, op, compareValue) {
      console.log('CPublicMultistatusContainer.opStatus', value, op, compareValue);
      switch (decodeURIComponent(op)) {
        case '=':
          return `${value}` === `${compareValue}`;
        case '<':
          return parseInt(value, 10) < parseInt(compareValue, 10);
        case '<=':
          return parseInt(value, 10) <= parseInt(compareValue, 10);
        case '>=':
          return parseInt(value, 10) >= parseInt(compareValue, 10);
        case '>':
          return parseInt(value, 10) > parseInt(compareValue, 10);
        case 'in':
          return compareValue.split('|').includes(`${value}`);
        default:
          return false;
      }
    },
    // 礼包领取记录判断状态
    packageInfoStatus(key, op, value) {
      const packageNum = this.packageInfo[key];
      console.log('packageInfoStatus|packageInfo = ,package =,packageNum = ', this.packageInfo, key, packageNum);
      if (packageNum === 'undefined') {
        return false;
      }
      return this.opStatus(packageNum, op, value);
    },
    // 流程返回判断
    async flowidLimitStatus(flowId, key, op, value) {
      console.log('CPublicMultistatusContainer.resAllArr.flowId', this.resAllArr[flowId]);
      const rspValue = this.resAllArr[flowId]?.data[key];
      console.log('CPublicMultistatusContainer.flowidLimitStatus.rsp', rspValue);
      // 兼容白名单类没有二级错误码返回的接口
      if (rspValue === 'undefined') {
        return false;
      }
      // console.log('rspValue', rspValue);
      return this.opStatus(rspValue, op, value);
    },
    // 时间判断
    timeLimitStatus(sTime, eTime) {
      const value = this.getServerTime();
      const sTimeNum = this.getTime(sTime);
      const eTimeNum = this.getTime(eTime);
      console.log('CPublicMultistatusContainer.timeLimitStatus', sTimeNum, value, eTimeNum);
      if (value >= sTimeNum && value <= eTimeNum) {
        return true;
      }
      return false;
    },
    // 账号类型判断
    acctypeLimitStatus(acctype) {
      let value = this.getCookie('acctype');
      if (value !== 'wx') {
        value = 'qc';
      }
      return this.opStatus(value, '=', acctype);
    },
    // 平台判断
    platformLimitStatus(plat) {
      const value = common.platform.device;
      return this.opStatus(value, '=', plat);
    },
    // 是否在app内
    isAPPLimitStatus(isAPP) {
      const value = this.isApp;
      console.log('CPublicMultistatusContainer.isAPPLimitStatus', value, isAPP);
      if (isAPP === '1' && value) {
        return true;
      }
      if (isAPP === '0' && !value) {
        return true;
      }
      return false;
    },
    // 是否在游戏内
    isGameLimitStatus(isGame) {
      const value = this.isGame;
      if (isGame === '1' && value) {
        return true;
      }
      if (isGame === '0' && !value) {
        return true;
      }
      return false;
    },
    // userAgentLimitStatus判断
    userAgentLimitStatus(userAgentStr) {
      const userAgentArr = userAgentStr.split('|');
      let userAgentLimitStatus = false;
      userAgentArr.forEach((item) => {
        if (navigator.userAgent.indexOf(item) > -1) {
          userAgentLimitStatus = true;
        }
      });
      return userAgentLimitStatus;
    },
    // channelIdLimitStatus判断
    channelIdLimitStatus(value) {
      const userAgentArr = value.split('|');
      console.log('common.tool', userAgentArr);
      let channelIdLimitStatus = false;
      userAgentArr.forEach((item) => {
        // const [urlKey = '', urlValue = ''] = item.split('=');
        if (window.location.href.indexOf(item) > -1) {
          channelIdLimitStatus = true;
        }
      });
      return channelIdLimitStatus;
    },
    // 多流程执行 记录结果
    async flowIdListLimitStatus() {
      console.log('flowIdListLimitStatus', this.configurationData?.flowIdList, this.isLogin);
      if (this.configurationData?.flowIdList) {
        // 根据配置读取返回值列表
        const that = this;
        const flowIdArr = this.configurationData?.flowIdList;
        const promiseList = flowIdArr.map(flow => that.flowRequest({
          flowId: flow.flowId,
          params: {
            role: this.roleInfo,
          },
        }));
        const resAll = (await Promise.allSettled(promiseList))
          .filter(request => request.status === 'fulfilled')
          .map(request => request.value);
        if (flowIdArr.length !== resAll.length) {
          return;
        }
        // console.log('resAll', resAll);
        for (let i = 0; i <= resAll.length - 1; i++) {
          this.resAllArr[flowIdArr[i].flowId] = resAll[i];
        }
        // console.log('rspValue ', this.resAllArr);
      }
    },
    getTime(str) {
      let newStr = str;
      if (this.$platform.isIos) {
        newStr = str.replace(/-/g, '/');
      }
      return new Date(newStr).getTime();
    },
    getServerTime() {
      // console.log("common.tool.getSeverDateTime()", common.tool.getSeverDateTime())
      console.log('common.tool.getSeverDateTime()', common.tool.getSeverDateTime().getTime());
      return common.tool.getSeverDateTime().getTime();
    },
    getCookie(key) {
      const reg = new RegExp(`(^| )${key}=([^;]*)(;|$)`);
      const arr = document.cookie.match(reg);
      if (arr) {
        return arr[2];
      }
      return null;
    },
    doTaskAction() {
      const nodeList = this.$refs.mainContainer.querySelectorAll('.csu-dynamic-container-content-slot') || [];
      for (let i = 0; i < nodeList.length; i++) {
        const node = nodeList[i];
        if (node && node.style.display !== 'none') {
          if (node.childNodes && node.childNodes.length > 0) {
            // 找到第一个按钮点击
            for (let k = 0; k < node.childNodes.length; k++) {
              if (node.childNodes[k]?.nodeName === 'BUTTON') {
                node.childNodes[k]?.click();
                return;
              }
            }
          }
          return;
        }
      }
    },
    // 当前游戏id判断状态
    currentGidStatus(gid, op = '=') {
      const value = `${this.currentGid}`;
      console.log('【currentGidStatus】', 'gid = ', value, gid, op);
      return this.opStatus(value, op, gid);
    },
    /**
     * 判断app版本
     * @param op
     * @param value
     * @returns {boolean}
     */
    appVersionLimitStatus(op, value) {
      const appVersion = this.$ast.appVersion();
      // 版本号比较 2102091384
      if (appVersion.indexOf('.')  === -1 && value.indexOf('.')  === -1) {
        return this.opStatus(appVersion, op, value);
      }
      // 版本比较 3.26.2.1274.2102091384
      const compareValue = this.compareAppVersion(appVersion, value);
      switch (op) {
        case '>':
          return compareValue === 1;
        case '>=':
          return compareValue === 1 || compareValue === 0;
        case '=':
          return compareValue === 0;
        case '<':
          return compareValue === -1;
        case '<=':
          return compareValue === -1 || compareValue === 0;
      }
      return false;
    },
    /**
     * 比较版本大小
     * @param appVersion
     * @param compareVersion
     * @returns {number} -1 app版本小于目标版本; 0 app版本等于目标版本; 1 app版本大于目标版本
     */
    compareAppVersion(appVersion, compareVersion) {
      const [v1 = 0, v2 = 0, v3 = 0, v4 = 0, v5 = 0] = appVersion.split('.').map(num => (num ? parseInt(num, 10) : 0));
      console.log('appVersion v1 v2 v3 v4 v5', v1, v2, v3, v4, v5);
      const [c1 = 0, c2 = 0, c3 = 0, c4 = 0, c5 = 0] = compareVersion.split('.').map(num => (num ? parseInt(num, 10) : 0));
      console.log('passThrough compareVersion c1 c2 c3 c4 c5', c1, c2, c3, c4, c5);
      if (v1 - c1 < 0) {
        return -1;
      }
      if (v1 - c1 > 0) {
        return 1;
      }
      if (v2 - c2 < 0) {
        return -1;
      }
      if (v2 - c2 > 0) {
        return 1;
      }
      if (v3 - c3 < 0) {
        return -1;
      }
      if (v3 - c3 > 0) {
        return 1;
      }
      if (v4 - c4 < 0) {
        return -1;
      }
      if (v4 - c4 > 0) {
        return 1;
      }
      if (v5 - c5 < 0) {
        return -1;
      }
      if (v5 - c5 > 0) {
        return 1;
      }
      if (v1 === c1 && v2 === c2 && v3 === c3 && v4 === c4 && v5 === c5) {
        return 0;
      }
      return -1;
    },
  },
};
</script>
<style lang="scss">
@import 'styles';
</style>
